import PageContainer from '@/common/components/PageContainer'
import { PermissionType } from '@/common/types'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionKeys } from '@/modules/manage-member/mappers'

import WithdrawByIdListing from '@/modules/transaction/components/WithdrawByIdListing'

function WithdrawByIdPage() {
	return (
		<PageContainer>
			<div className="flex-1 space-y-4">
				<WithdrawByIdListing />
			</div>
		</PageContainer>
	)
}

const GuardedWithdrawByIdPage = withUserPermission(WithdrawByIdPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_BANK_TRANSACTION],
})

export default GuardedWithdrawByIdPage
